
import React from 'react';

const FeaturesGrid = ({ features, imageUrl, featureOrder='order-1', imageOrder='order-2' }) => {
 
  const leftFeatures = features.slice(0, 2);
  const rightFeatures = features.slice(2, 4);
  const middleFeature = features.slice(4,6);

  return (
    <div className="mx-auto max-sm:px-2 max-xl:px-4">
      <div className={`font-poppins relative grid grid-cols-1 ${imageUrl || features.length>4?"lg:grid-cols-3":"lg:grid-cols-2 gap-0 lg:gap-y-12 lg:gap-x-8"} justify-center`}>
        <div className={`space-y-8 max-lg:${featureOrder} flex lg:gap-4 flex-col max-lg:mb-8`}>
          {leftFeatures.map((feature, index) => (
            <div key={index} className="text-left lg:space-y-3">
              <h3 className="text-darkGray text-xl font-bold mb-5">
                {feature.title}
              </h3>
              <p className={`text-darkGray/70 text-base sm:text-sm ${middleFeature && features.length > 4 ? 'lg:max-w-[370px]':'lg:max-w-[390px]'}`}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
        {middleFeature && features.length > 4 && <div className={`space-y-8 flex lg:gap-4 flex-col max-lg:${imageOrder} max-lg:mb-8 mb-5`}>
          {middleFeature.map((feature, index) => (
            <div key={index} className="text-left lg:space-y-3">
              <h3 className="text-darkGray text-xl font-bold mb-5">
                {feature.title}
              </h3>
              <p className="text-darkGray/70 text-base sm:text-sm lg:max-w-[390px]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>}
        {imageUrl && <div className="flex justify-center items-center max-lg:order-1">
          {imageUrl && (
            <div className="relative w-full max-w-md max-sm:py-6">
              <img
                src={imageUrl}
                alt="Feature Center img"
                width={400}
                height={400}
                className="w-full h-auto"
              />
            </div>
          )}
        </div> }
        <div className="space-y-8 max-lg:order-3 flex lg:gap-4 flex-col">
          {rightFeatures.map((feature, index) => (
            <div key={index} className="text-left space-y-3">
              <h3 className="text-darkGray text-xl font-bold mb-5">
                {feature.title}
              </h3>
              <p className="text-darkGray/70 text-base sm:text-sm lg:max-w-[390px]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturesGrid;
